import { createAction } from 'redux-actions';

export const PLAY_MUSIC = createAction('PLAY_MUSIC');
export const STOP_MUSIC = createAction('STOP_MUSIC');
export const UPDATE_MUSIC_DATA = createAction('UPDATE_MUSIC_DATA');
export const SOUND_NOT_AVAILABLE_FOR_THIS_DEVICE = createAction('SOUND_NOT_AVAILABLE_FOR_THIS_DEVICE');
